import {color, font, type} from "common/tokens";

// The question widgets are shared with signup and the admin forms, where they
// still carry their old Material look. Spread this into a wrapper rule to put
// a surveyed or quizzed question on the redesign's fields without touching the
// widgets themselves.
const questionFields = {
  '& .MuiInputBase-root': {
    background: color.SURFACE,
    borderRadius: 12,
    minHeight: 52,
    border: `1px solid ${color.BORDER}`,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiInputBase-input': {
    ...type.body,
    color: color.TEXT,
    padding: '14px 16px',
  },
  '& .radio-toolbar label': {
    ...type.body,
    fontWeight: font.MEDIUM,
    background: color.SURFACE,
    color: color.TEXT,
    border: `1px solid ${color.BORDER} !important`,
    borderRadius: '12px !important',
    padding: '14px 16px !important',
    boxShadow: 'none',
  },
  '& .radio-toolbar input[type="radio"]:checked + label': {
    background: `${color.ACCENT_TINT} !important`,
    borderColor: `${color.ACCENT} !important`,
    color: `${color.TEXT} !important`,
  },
  '& .MuiSelect-select': {
    padding: '14px 16px',
  },
  '& .MuiSvgIcon-root': {
    color: color.TEXT_MUTED,
  },
};

export default questionFields;
